<div class="sui-pagination">
  <sui-button
    variant="ghost"
    size="sm"
    [iconOnly]="true"
    [iconFixedWidth]="true"
    [leadingIcon]="faFirst"
    ariaLabel="First page"
    [disabled]="isFirst"
    (click)="goTo(1)"
  ></sui-button>
  <sui-button
    variant="ghost"
    size="sm"
    [iconOnly]="true"
    [iconFixedWidth]="true"
    [leadingIcon]="faPrev"
    iconTransform="grow-6"
    ariaLabel="Previous page"
    [disabled]="isFirst"
    (click)="goTo(currentPage - 1)"
  ></sui-button>

  @if (collectionSize > 0) {
    <span class="sui-pagination__page">
      <input
        #pageInput
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        class="sui-pagination__input"
        [value]="currentPage"
        (keyup.enter)="onInputEnter(pageInput.value)"
        (input)="clampInput()"
        aria-label="Page number"
      />
      <span class="sui-pagination__total"
        >/ {{ pageCount | number: "1.0-0" }}</span
      >
    </span>
  }

  <sui-button
    variant="ghost"
    size="sm"
    [iconOnly]="true"
    [iconFixedWidth]="true"
    [leadingIcon]="faNext"
    iconTransform="grow-6"
    ariaLabel="Next page"
    [disabled]="isLast"
    (click)="goTo(currentPage + 1)"
  ></sui-button>
  <sui-button
    variant="ghost"
    size="sm"
    [iconOnly]="true"
    [iconFixedWidth]="true"
    [leadingIcon]="faLast"
    ariaLabel="Last page"
    [disabled]="isLast"
    (click)="goTo(pageCount)"
  ></sui-button>
</div>
